import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const profileWidgets = makeDynamicConfigWidgets([
  {
    name: 'profileForm',
    cols: 6,
  },
  {
    name: 'clerkProfile',
    cols: 6,
  },
]);
